import { Action, action, FilterActionTypes, StateMapper } from 'easy-peasy';
import translationMessages from '../intl';

export interface IntlModel {
  locale: string;
  messages: Record<string, string>;
  update: Action<IntlModel, string>;
}

const defaultLocale = window.navigator.language === 'fr-FR' ? 'fr' : 'en';

const intl: IntlModel = {
  locale: defaultLocale,
  messages: translationMessages[defaultLocale],
  update: action((state: StateMapper<FilterActionTypes<IntlModel>>, payload: string) => {
    state.locale = payload;
    state.messages = translationMessages[payload];
  }),
};

export default intl;
